<template>
  <!-- 管理车辆 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search" v-permission="['manageVehicles:search']">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <el-form-item :label="$t('pages.equipment.text8')">
          <el-input
            v-model="searchParams.batchId"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text7')">
          <el-input
            v-model="searchParams.bikeCode"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('omission.text25')">
          <el-select
            v-model="searchParams.type"
            clearable
            :placeholder="$t('public.text5')"
          >
            <el-option
              :label="$t('pages.operate.text10')"
              :value="null"
            ></el-option>
            <el-option :label="$t('omission.text26')" :value="0"> </el-option>
            <el-option :label="$t('omission.text27')" :value="1"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton type="search" @click="search"></DiluButton>
        <DiluButton type="reset" @click="reset"></DiluButton>
      </div>
    </div>

    <!-- 按钮区域 -->
    <div class="operation">
      <DiluButton
        v-permission="['manageVehicles:relation']"
        buttonType="primary"
        type="custom"
        @click="relationAll()"
        :title="$t('omission.text28')"
        :disabled="selectIds.length < 1"
      ></DiluButton>
      <DiluButton
        v-permission="['manageVehicles:disassociate']"
        type="custom"
        @click="disassociateAll()"
        :title="$t('omission.text29')"
        :disabled="selectIds.length < 1"
      ></DiluButton>
    </div>

    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :pageSize="searchParams.pageSize"
      @currentChange="currentChange"
      @handleSelectionChange="handleSelectionChange"
      :total="total"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="date" label="#" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="batchId"
        :label="$t('pages.equipment.text8')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="bikeCode"
        :label="$t('pages.equipment.text7')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="deviceCode"
        :label="$t('omission.text3')"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
        fixed="right"
        width="120px"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button
              v-permission="['manageVehicles:relation']"
              v-if="scope.row.status == 0"
              @click="relation(scope.row)"
              type="text"
              >{{ $t("omission.text30") }}</el-button
            >
            <el-button
              v-else
              @click="disassociate(scope.row)"
              type="text"
              v-permission="['manageVehicles:disassociate']"
              >{{ $t("omission.text29") }}</el-button
            >
          </div>
        </template>
      </el-table-column>
    </DiluTable>
  </div>
</template>


<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
export default {
  data() {
    return {
      total: 0,
      searchParams: {
        id: "", //	电子围栏Id
        batchId: "", //批次Id
        bikeCode: "", //	车辆编码
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        type: null, //关联状态，0-已关联，1-未关联
      },
      selectIds: [],
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      tableData: [],
      isSerch: false, //是否在查询
    };
  },
  components: {
    DiluTable,
    DiluButton,
  },

  mounted() {
    this.searchParams.id = this.$route.query.id;
    this.listGeoInBike();
  },
  methods: {
    //批量取消关联
    disassociateAll() {
      let that = this;
      let params = {
        bikeCodeAndDeviceCodeBean: [],
        id: that.$route.query.id,
      };
      let arr = [];
      let arr1 = [];
      for (let i in this.tableData) {
        if (this.tableData[i].status == 1) {
          arr.push({
            bikeCode: this.tableData[i].bikeCode,
            deviceCode: this.tableData[i].deviceCode,
          });
        }
      }

      for (let i in arr) {
        for (let j in that.selectIds) {
          if (arr[i].bikeCode == that.selectIds[j]) {
            arr1.push(arr[i]);
          }
        }
      }

      if (arr1.length < 1) {
        return that.$message({
          message: that.$t("omission.text33"),
          type: "warning",
        });
      }

      params.bikeCodeAndDeviceCodeBean = arr1;
      this.request.disassociateBike(params).then(() => {
        this.$message.success(that.$t("omission.text32"));
        this.listGeoInBike();
      });
    },
    //批量关联
    relationAll() {
      let that = this;
      let params = {
        bikeCodeAndDeviceCodeBean: [],
        id: that.$route.query.id,
      };
      let arr = [];
      let arr1 = [];
      for (let i in this.tableData) {
        if (this.tableData[i].status == 0) {
          arr.push({
            bikeCode: this.tableData[i].bikeCode,
            deviceCode: this.tableData[i].deviceCode,
          });
        }
      }

      for (let i in arr) {
        for (let j in that.selectIds) {
          if (arr[i].bikeCode == that.selectIds[j]) {
            arr1.push(arr[i]);
          }
        }
      }

      if (arr1.length < 1) {
        return that.$message({
          message: that.$t("omission.text34"),
          type: "warning",
        });
      }

      params.bikeCodeAndDeviceCodeBean = arr1;
      this.request.relationBike(params).then(() => {
        this.listGeoInBike();
        this.$message.success(that.$t("omission.text31"));
      });
    },
    //关联
    relation(e) {
      let that = this;
      let params = {
        bikeCodeAndDeviceCodeBean: [],
        id: that.$route.query.id,
      };
      params.bikeCodeAndDeviceCodeBean.push({
        bikeCode: e.bikeCode,
        deviceCode: e.deviceCode,
      });
      this.request.relationBike(params).then(() => {
        this.listGeoInBike();
        this.$message.success(that.$t("omission.text31"));
      });
    },
    //取消关联
    disassociate(e) {
      let that = this;
      let params = {
        bikeCodeAndDeviceCodeBean: [],
        id: that.$route.query.id,
      };
      params.bikeCodeAndDeviceCodeBean.push({
        bikeCode: e.bikeCode,
        deviceCode: e.deviceCode,
      });
      this.request.disassociateBike(params).then(() => {
        this.$message.success(that.$t("omission.text32"));
        this.listGeoInBike();
      });
    },
    //重置
    reset() {
      this.isSerch = false; //是否在查询
      let that = this;
      this.searchParams = {
        id: that.$route.query.id, //	电子围栏Id
        batchId: "", //批次Id
        bikeCode: "", //	车辆编码
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        type: null, //关联状态，0-已关联，1-未关联
      };
      this.total = 0;
      this.listGeoInBike();
    },
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.listGeoInBike();
    },
    //选中触发
    handleSelectionChange(e) {
      this.selectIds = e.map((item) => {
        return item.bikeCode;
      });
    },
    //获取车辆管理列表
    listGeoInBike() {
      this.request.listGeoInBike(this.searchParams).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
      });
    },
    //翻页
    currentChange(e) {
      let that = this;
      if (!this.isSerch) {
        this.searchParams = {
          id: that.$route.query.id, //	电子围栏Id
          batchId: "", //批次Id
          bikeCode: "", //	车辆编码
          pageNum: 1, //页码
          pageSize: 10, //每页条数
          type: null, //关联状态，0-已关联，1-未关联
        };
      }
      this.searchParams.pageNum = e;
      this.listGeoInBike();
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
  height: 60px;
}
</style>